import { getValueFromKey } from './WindowEnvironmentRetriver';

export const env = (key: string): string => {
  const value = getValueFromKey(key);
  if (!value) {
    throw new Error(`${key} is not set`);
  }
  return value;
};

export const envNoError = (key: string): string => {
  const value = getValueFromKey(key);
  if (!value) {
    return '';
  }
  return value;
};

export const formatRedirectUri = (redirectUri: string): string => {
  const originUrl = addSlashToOriginPath(window.location.origin);
  return `${originUrl}${redirectUri}`;
};

// origin may or may not have the "/" at the end. if it isn't there, we append it
export const addSlashToOriginPath = (origin: string): string => {
  return origin.endsWith('/') ? origin : `${origin}/`;
};
